import React from 'react';
import PerguntaForm from './PerguntaForm';
import PerguntaService from 'services/perguntasService';

const NovaPergunta = ({ closeModal, atualizarPerguntas, isSubPergunta, perguntaPai }) => {  // Recebendo isSubPergunta e perguntaPai como props
  const handleSubmit = async (data) => {
    await PerguntaService.criarPergunta(data);
  };

  return (
    <PerguntaForm
      handleSubmit={handleSubmit}
      closeModal={closeModal}
      atualizarPerguntas={atualizarPerguntas}
      isSubPergunta={isSubPergunta}  // Passando isSubPergunta para o formulário
      perguntaPai={perguntaPai}      // Passando perguntaPai para o formulário
    />
  );
};

export default NovaPergunta;
